import React from 'react';
import { Data } from '../../types/data-providers';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { useData, dataFromDataset } from './DataProviderCache';
import * as ManageAlarmManager from '../domain/manage-alarms-manager';
import { GatewayListType } from '../../types';

type ContextState = Data<GatewayListType[]>;

const Context = React.createContext<ContextState | null>(null);

function useGatewayDeviceList(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useGatewayDeviceList must be used within a GatewayDeviceList');
    }
    return contextState;
}

const GatewayDeviceListProvider: React.FC<{ siteId: string; profileId: string }> = (props) => {
    const authHelper = useAuthHelper();

    const { dataset } = useData({
        cacheKey: 'gateway-device-list',
        id: `${props.siteId}-${props.profileId}`,
        dataFn: React.useCallback(
            () =>
                ManageAlarmManager.getGatewayDevices(authHelper, {
                    siteId: props.siteId,
                    profileId: props.profileId,
                }),
            [authHelper, props.siteId, props.profileId]
        ),
    });
    const gatewayDevices = dataFromDataset(dataset);

    return <Context.Provider value={gatewayDevices}>{props.children}</Context.Provider>;
};

const TestSiteDevicesDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { GatewayDeviceListProvider, TestSiteDevicesDataProvider, useGatewayDeviceList };
